// extracted by mini-css-extract-plugin
module.exports = {"Ondemand":"style_Ondemand__2gJjD","hr":"style_hr__BN2bi"};